import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { CheckCircle2Icon } from 'lucide-react';
export function WhatIncludesSection() {
  const items = ['Plan de comida simple (sin pensar)', 'Rutina diaria guiada (mañana + noche)', 'Entrenamiento adaptado a tu nivel', 'Journaling estructurado', 'Tracker diario (2 min por día)', 'Acompañamiento 1:1 por WhatsApp'];
  return <section className="py-10 md:py-28 bg-charcoal relative" data-id="element-357">
      <div className="max-w-3xl mx-auto px-6" data-id="element-358">
        <FadeIn data-id="element-359">
          <div className="bg-charcoal-dark border border-sand/20 rounded-sm p-8 md:p-12 shadow-[0_0_60px_rgba(212,165,116,0.04)]" data-id="element-360">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-sand mb-8 md:mb-10 text-center" data-id="element-361">
              Qué incluye RESET 7D
            </h2>

            <ul className="space-y-4 md:space-y-5 mb-8 md:mb-10" data-id="element-362">
              {items.map((item, idx) => <FadeIn key={idx} delay={idx * 0.08} direction="up" data-id="element-363">
                  <li className="flex items-center gap-4" data-id="element-364">
                    <CheckCircle2Icon className="w-5 h-5 text-sand shrink-0" data-id="element-365" />
                    <span className="text-base md:text-lg text-offwhite leading-relaxed" data-id="element-366">
                      {item}
                    </span>
                  </li>
                </FadeIn>)}
            </ul>

            <FadeIn delay={0.5} data-id="element-367">
              <p className="text-center text-offwhite-dim/70 italic text-sm md:text-base mb-8 md:mb-10" data-id="element-368">
                Todo por WhatsApp. Sin apps. Sin complicaciones.
              </p>
            </FadeIn>

            <FadeIn delay={0.6} className="text-center" data-id="element-369">
              <Button href="https://wa.link/we351n" size="lg" withArrow className="w-full md:w-auto" data-id="element-370">
                Escribí RESET → $47 esta semana (quedan 5 cupos)
              </Button>
            </FadeIn>
          </div>
        </FadeIn>
      </div>
    </section>;
}